import { useCan, useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { AcsesDashboardQueryKeys } from "modules/AcsesLogsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { WebhookHistoryResponse } from "modules/AcsesLogsDashboard/queryKeys";

const mapAcsesLogsWithParsedSentContent = ({ history }: WebhookHistoryResponse) => history.map(h => ({ ...h, sentContent: JSON.parse(h.sentContent) }));

export const useAcsesLogsQuery = () => {
  const { selectedLocation } = useSelectedLocation();
  const canListAcsesHistory = useCan("list", "acses-history");

  return useTypedQuery({
    queryKey: AcsesDashboardQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data,
    select: mapAcsesLogsWithParsedSentContent,
    enabled: Boolean(selectedLocation?.id) && canListAcsesHistory,
    refetchOnDependencies: [selectedLocation?.id]
  });
};
